module.exports = __webpack_public_path__ + "img/appel-en-banaanstukjes-in-bakvorm.3b5aa42b.jpg";